import React, { Fragment } from "react";
import {
  Grid,
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  CardMedia,
  Avatar,
  OutlinedInput,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { useAuth } from "context/authContext";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";

interface CardData {
  promoCode: string;
  isPromoApplied: any;
  id: string;
  author: string;
  afterCoupon: number;
  quantity: number;
  contentData: any;
}

interface ViewAllCardsProps {
  data: CardData[];
  onQuantityChange?: (id: string, delta: number) => void;
  onDelete?: (id: string) => void;
  removePromoCode: (id: string) => void;
  handlePromoCodeChange: (id: string, value: string) => void;
  applyPromoCode: (id: string) => void;
  titleColor?: string;
  titleFontWeight?: number;
  titleFontSize?: string;
  iconPaths?: {
    category: string;
    author: string;
    course: string;
    delete: string;
    handoutIcon: string;
    courseIcon: string;
  };
}

const CheckOutCommon: React.FC<ViewAllCardsProps> = ({
  data,
  onQuantityChange,
  onDelete,
  removePromoCode,
  handlePromoCodeChange,
  applyPromoCode,
  titleColor = "#797979",
  titleFontWeight = 700,
  titleFontSize = "18px",
  iconPaths = {
    category: "assets/icons/affcategory.png",
    author: "assets/icons/affprofile.png",
    course: "assets/icons/affcourse.png",
    delete: "assets/icons/iconDelete.png",
    handoutIcon: "assets/icons/checkoutHandout.svg",
    courseIcon: "assets/icons/checkoutCourse.svg",
  },
}) => {
  const { currentUser } = useAuth();

  return (
    <Grid display="flex" gap={5} flexDirection="column" pb={5}>
      {data.map((item) => (
        <Fragment key={item.id}>
          <Box
            display={{ xs: "flex", md: "none" }} alignItems={"center"}
            justifyContent={"space-between"}>

            <Box
              sx={{ borderBottom: "1px solid #D6D6D6", width: { xs: "100%", md: "1120px" } }}
            >
            </Box>
            {/* <Box
              display="flex"
              alignItems="center"
              sx={{
                cursor: "pointer", border: "1px solid #D6D6D6", borderRadius: "100%",
                p: "5px"
              }}
              onClick={() => onDelete && onDelete(item.id)}
            >
              <img src={iconPaths.delete} alt="Delete Icon" />

            </Box> */}
          </Box>

          <Card sx={styleSheet.cardContainer}>
            <Box display={"flex"} flexWrap={{ xs: "wrap", md: "nowrap" }}>
              <Box display={"flex"} flexDirection={"column"} gap={"18px"}
              >

                {/* /// set this mobile screen /// */}
                <Box display={{ xs: "flex", md: "none" }} alignItems={"center"} gap={"18px"}
                  ml={{ xs: 2, md: 0 }}>
                  <CardMedia
                    component="img"
                    sx={{ width: 110, height: 84, borderRadius: "2.86px", }}
                    image={item?.contentData?.coverPhotoUrl}
                    alt={item?.contentData?.title}
                  />
                  {item?.contentData?.type === "handout" && (
                    <>

                      <Box
                        display="flex"
                        alignItems="center"
                        width={97}
                        height={31}
                        sx={{
                          // ml: 2,
                          border: "1px solid #d3d3d3",
                          borderRadius: "5px",
                        }}
                      >
                        <Button
                          sx={{ color: "#d3d3d3", minWidth: 40 }}
                          onClick={() =>
                            onQuantityChange &&
                            onQuantityChange(item.id.toString(), -1)
                          }
                        >
                          <RemoveIcon />
                        </Button>
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                          sx={{ width: 40, fontWeight: "bold" }}
                        >
                          {item.quantity}
                        </Box>
                        <Button
                          sx={{ color: "#d3d3d3", minWidth: 40 }}
                          onClick={() =>
                            onQuantityChange &&
                            onQuantityChange(item.id.toString(), 1)
                          }
                        >
                          <AddIcon />
                        </Button>
                      </Box>
                    </>
                  )}
                </Box>
                {/* /// mobile screen end /// */}


                {/* /// this full screen /// */}
                <CardMedia
                  component="img"
                  sx={{ width: 204, height: 160, borderRadius: "10px", display: { xs: "none", md: "flex" } }}
                  image={item?.contentData?.coverPhotoUrl}
                  alt={item?.contentData?.title}
                />
                <Box
                  display={{ xs: "none", md: "flex" }}
                  alignItems="center"
                  justifyContent="space-between"
                >
                  {item?.contentData?.type === "handout" && (
                    <>
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: "18px",
                          color: "#797979",
                        }}
                      >
                        Quantity
                      </Typography>
                      <Box
                        display="flex"
                        alignItems="center"
                        width={97}
                        height={31}
                        sx={{
                          ml: 2,
                          border: "1px solid #d3d3d3",
                          borderRadius: "5px",
                        }}
                      >
                        <Button
                          sx={{ color: "#d3d3d3", minWidth: 40 }}
                          onClick={() =>
                            onQuantityChange &&
                            onQuantityChange(item.id.toString(), -1)
                          }
                        >
                          <RemoveIcon />
                        </Button>
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                          sx={{ width: 40, fontWeight: "bold" }}
                        >
                          {item.quantity}
                        </Box>
                        <Button
                          sx={{ color: "#d3d3d3", minWidth: 40 }}
                          onClick={() =>
                            onQuantityChange &&
                            onQuantityChange(item.id.toString(), 1)
                          }
                        >
                          <AddIcon />
                        </Button>
                      </Box>
                    </>
                  )}
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  flexGrow: 1,
                  ml: { xs: 0, md: 3 },
                }}
              >
                <Box display={"flex"} flexWrap={{ xs: "wrap", md: "nowrap" }} gap={1} alignItems={"center"}>
                  <CardContent
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                      p: 0,
                      ml: { xs: 2, md: 0 },
                    }}
                  >
                    <Typography
                      component="div"
                      variant="h6"
                      sx={{
                        fontWeight: titleFontWeight,
                        fontSize: titleFontSize,
                        width: "237px",
                        color: "#797979",
                        mt: { xs: 1, md: 0 },
                      }}
                    >
                      {item?.contentData?.title}
                    </Typography>
                    <Box display="flex" alignItems="center" gap={1}>
                      <img src={iconPaths.category} alt="Category Icon" />
                      <Typography
                        variant="subtitle1"
                        color="text.secondary"
                        component="div"
                        sx={{ fontWeight: 400, fontSize: "17px", width: "237px", }}
                      >
                        {item?.contentData?.category}
                      </Typography>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                      <Avatar
                        alt="profile"
                        src={
                          item?.contentData?.createdBy?.profileUrl ||
                          "/static/images/avatar/1.jpg"
                        }
                        sx={{
                          width: { xs: 30, md: 24 },
                          height: { xs: 30, md: 24 },
                        }}
                      />
                      <Typography
                        variant="subtitle1"
                        color="text.secondary"
                        component="div"
                        sx={{ fontWeight: 400, fontSize: "17px" }}
                      >
                        {item?.contentData?.createdBy?.firstName
                          ? `${item?.contentData?.createdBy?.firstName} ${item?.contentData?.createdBy?.lastName || ""
                          }`
                          : "not user name"}
                      </Typography>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                      {item?.contentData?.type === "handout" ? (
                        <img src={iconPaths.handoutIcon} alt="Handout Icon" />
                      ) : (
                        <img src={iconPaths.courseIcon} alt="Course Icon" />
                      )}
                      {/* <img src={iconPaths.course} alt="Course Icon" /> */}
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        component="div"
                        sx={{ fontWeight: 400, fontSize: "17px" }}
                      >
                        {item?.contentData?.type}
                      </Typography>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: "18px",
                          color: "#797979",
                        }}
                      >
                        Total:
                      </Typography>
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: "18px",
                          color: "#797979",
                        }}
                      >
                        {item.isPromoApplied ? (
                          <>
                            <s style={{ color: "red", marginLeft: "5px" }}>
                              {item.quantity} x${item?.contentData?.price}=
                              {(Number(item?.contentData?.price) || 0) *
                                (Number(item.quantity) || 1)}
                            </s>
                            <span style={{ marginLeft: "10px" }}>
                              {" "}
                              {item.quantity} x${item.afterCoupon}=
                              {(Number(item.afterCoupon) || 0) *
                                (Number(item.quantity) || 1)}
                            </span>
                          </>
                        ) : (
                          // Regular Price when promo is not applied
                          <>{item?.contentData?.price * item.quantity} </>
                        )}
                      </Typography>
                    </Box>
                  </CardContent>
                  <Box
                    sx={{ display: { xs: "block", md: "none" }, pt: 1, borderBottom: "1px solid #D6D6D6", width: { xs: "79%" } }}
                  >

                  </Box>
                  <CardContent
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                      alignItems: "end",
                      p: 0,
                    }}
                  >
                    <Box display={"flex"} alignItems={"center"}
                      flexWrap={{ xs: "wrap", md: "nowrap" }} gap={1} mt={{ xs: 0, md: 7 }}>
                      <Typography
                        fontSize={18}
                        fontWeight={700}
                        color={"#233F91"}
                      >
                        Promo Code
                      </Typography>

                      <Box display={"flex"} gap={2} alignItems="center">
                        <OutlinedInput
                          id="outlined-adornment-weight"
                          placeholder="Enter your promotion code"
                          sx={styleSheet.outLineInput}
                          disabled={item.isPromoApplied}
                          value={item.promoCode}
                          onChange={(e) =>
                            handlePromoCodeChange(item.id, e.target.value)
                          }
                          endAdornment={
                            <InputAdornment position="end">
                              <Button
                                sx={{
                                  ...styleSheet.outLineBtn,
                                  bgcolor: item.isPromoApplied
                                    ? "#737373"
                                    : "#233F91",

                                  "&:hover": {
                                    bgcolor: item.isPromoApplied
                                      ? "#737373"
                                      : "#1A73E8",
                                  },
                                }}
                                disabled={item.isPromoApplied}
                                onClick={() => applyPromoCode(item.id)}
                              >
                                Apply
                              </Button>
                            </InputAdornment>
                          }
                          aria-describedby="outlined-weight-helper-text"
                          inputProps={{
                            "aria-label": "weight",
                          }}
                        />
                      </Box>
                    </Box>
                    {item.isPromoApplied && (
                      <Box display="flex" alignItems="center" gap={1} mt={1} mr={{ xs: 9, md: 0 }}>
                        <Typography
                          fontSize={17}
                          fontWeight={400}
                          color={"#1DA944"}
                        >
                          {item.promoCode} applied
                        </Typography>
                        <IconButton
                          size="small"
                          onClick={() => removePromoCode(item.id)}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    )}

                  </CardContent>
                </Box>
              </Box>
            </Box>
            <Box
              display={{ xs: "none", md: "flex" }}

              alignItems="center"
              gap={1}
              sx={{ cursor: "pointer", mt: 4, ml: 2 }}
            >
              <img src={iconPaths.delete} alt="Delete Icon" />
              <Typography
                variant="body2"
                color="text.secondary"
                onClick={() => onDelete && onDelete(item.id)}
                component="div"
                sx={{
                  fontWeight: 500,
                  fontSize: "20px",
                  color: "#E10A0A",
                }}
              >
                Remove
              </Typography>
            </Box>
          </Card>
        </Fragment>
      ))}
    </Grid>
  );
};

export default CheckOutCommon;

const styleSheet = {
  textRight: {
    fontSize: "18px",
    fontWeight: 700,
    color: "#797979",
  },
  textRightNumber: {
    fontSize: "18px",
    fontWeight: 700,
    color: "#2E2E2E",
    paddingLeft: "5px",
  },

  cardContainer: {
    display: "flex",
    alignItems: "center",
    flexWrap: { xs: "wrap", md: "nowrap" },
    padding: 1,
    width: { xs: "100%", md: "1112px" },
    boxShadow: "none",
    borderRadius: "0",
  },
  appliedCode: {
    border: "1px solid #D3D3D3",
    borderRadius: "15px",
    px: "10px",
    width: "283px",
    height: "52px",
  },
  outLineInput: {
    // width: "283px",
    width: "220px",
    height: "52.15px",
    borderRadius: "15px",
    paddingRight: "3px",
    fontSize: "14.53px",
    fontWeight: 400,
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#D3D3D3",
    },
  },
  outLineBtn: {
    width: "81px",
    height: "48px",
    borderRadius: "15px",
    bgcolor: "#233F91",
    color: "#fff",
    "&:hover": {
      bgcolor: "#1A73E8",
    },
  },
};
